exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amplify-album[data-v-77a314c9]{width:var(--component-width-desktop);margin:1em auto;border-radius:6px;background-color:var(--color-white);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow)\n}\n.amplify-album-container[data-v-77a314c9]{width:400px;margin:0 auto;padding:1em\n}\n.amplify-image-container[data-v-77a314c9]{display:inline\n}", ""]);

// exports
